import { DataService } from '../../utils/dataService'
import { AxiosResponse } from 'axios'
import { datadogLogs } from '@datadog/browser-logs'


import config from '../../config/enviroment'


export const LOADING_DETAILS = 'LOADING_DETAILS'
export const LOAD_DETAILS = 'LOAD_DETAILS'
export const SHOW_DETAILS = 'SHOW_DETAILS'
export const HIDE_DETAILS = 'HIDE_DETAILS'
export const DETAILS_ERROR = 'DETAILS_ERROR'
export const SHOW_SUMMARY_MODAL = 'SHOW_SUMMARY_MODAL'
export const HIDE_SUMMARY_MODAL = 'HIDE_SUMMARY_MODAL'
export const GET_TYPE_ADDRESS = 'GET_TYPE_ADDRESS'
export const FORM_FIRST_NAME = 'FORM_FIRST_NAME'
export const FORM_NAME = 'FORM_NAME'
export const FORM_LAST_NAME = 'FORM_LAST_NAME'
export const FORM_DOCUMENT_ID = 'FORM_DOCUMENT_ID'
export const FORM_DOCUMENT_ID_NOMENCLATURE = 'FORM_DOCUMENT_ID_NOMENCLATURE'
export const FORM_EMAIL = 'FORM_EMAIL'
export const FORM_PHONE = 'FORM_PHONE'
export const FORM_NOMENCLATURE = 'FORM_NOMENCLATURE'
export const FORM_ADRESS1 = 'FORM_ADRESS1'
export const FORM_ADRESS2 = 'FORM_ADRESS2'
export const FORM_ADRESS3 = 'FORM_ADRESS3'
export const FORM_COMPLEMENT = 'FORM_COMPLEMENT'
export const FORM_CITY = 'FORM_CITY'
export const CUSTOM_SHIPPING_VALUE = 'CUSTOM_SHIPPING_VALUE'
export const CUSTOM_SHIPPING_STATUS = 'CUSTOM_SHIPPING_STATUS'
export const SHIPPING_VALUE = 'SHIPPING_VALUE'
export const PAYMENT_METHOD = 'PAYMENT_METHOD'
export const PAYMENT_METHOD_BOOLEAN = 'PAYMENT_METHOD_BOOLEAN'
export const SEARCH_BUYER = 'SEARCH_BUYER'
export const RESET_DETAILS = 'RESET_DETAILS';



export const handleShowDetails = () => (dispatch: any) => {
  dispatch({
    type: SHOW_DETAILS
  })
}

export const handleResetDetails = () => (dispatch: any) => {
  dispatch({
    type: RESET_DETAILS
  })
}

export const handleHideDetails = () => (dispatch: any) => {
  dispatch({
    type: HIDE_DETAILS
  })
}

export const handleShowSummary = () => (dispatch: any) => {
  dispatch({
    type: SHOW_SUMMARY_MODAL
  })
}

export const handleHideSummary = () => (dispatch: any) => {
  dispatch({
    type: HIDE_SUMMARY_MODAL
  })
}


export const handleFormName = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_NAME,
    payload:data

  })
}

export const handleFormFirstName = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_FIRST_NAME,
    payload:data

  })
}

export const handleFormLastName = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_LAST_NAME,
    payload:data

  })
}


export const handleFormDocumentId = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_DOCUMENT_ID,
    payload:data

  })
}

export const handleFormDocumentIdNomenclature = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_DOCUMENT_ID_NOMENCLATURE,
    payload:data

  })
}

export const handleFormEmail = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_EMAIL,
    payload:data

  })
}

export const handleFormPhone = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_PHONE,
    payload:data

  })
}

export const handleFormNomenclature = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_NOMENCLATURE,
    payload:data

  })
}
export const handleFormAdress1 = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_ADRESS1,
    payload:data

  })
}
export const handleFormAdress2 = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_ADRESS2,
    payload:data

  })
}
export const handleFormAdress3 = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_ADRESS3,
    payload:data

  })
}
export const handleFormComplement = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_COMPLEMENT,
    payload:data

  })
}

export const handleFormCity = (data: any) => (dispatch: any) => {
  dispatch({
    type: FORM_CITY,
    payload:data

  })
}

export const handleShippingValue = (data: any) => (dispatch: any) => {
  dispatch({
    type: SHIPPING_VALUE,
    payload:data

  })
}


export const handleCustomShippingValue = (value: any) => (dispatch: any) => {
  dispatch({
    type: CUSTOM_SHIPPING_VALUE,
    payload: value
  })
}

export const handleCustomShippingStatus = (value: any) => (dispatch: any) => {
  dispatch({
    type: CUSTOM_SHIPPING_STATUS,
    payload: value
  })
}

export const handlePaymentMethod = (value: any) => (dispatch: any) => {
  dispatch({
    type: PAYMENT_METHOD,
    payload: value
  })
}

export const handlePaymentMethodBoolean = (value: any) => (dispatch: any) => {
  dispatch({
    type: PAYMENT_METHOD_BOOLEAN,
    payload: value
  })
}

export const handleLoadingInfo = (value: any) => (dispatch: any) => {
  dispatch({
    type: LOADING_DETAILS,
    payload: value
  })
}

export const handleLoadShipping = (value: any) => (dispatch: any) => {
  dispatch({
    type: LOAD_DETAILS,
    payload: value
  })
}

// keepAveonlineFlag: el formulario Aveonline (AddressInfoAveonline) sí necesita
// el isAveonline histórico del comprador para precargar sus campos de calle
// (ver AddressInfoAveonline.tsx:690). El formulario estándar (AnddressInfo) lo
// llama con `false`, porque ahí ese flag viejo puede forzar el flujo Aveonline
// en un comercio que ya lo desinstaló (VEN-4018), sin que haga falta ningún
// dato de precarga que dependa de él.
export const handleSearchBuyer = (
  email: string,
  path: string,
  catalogueId: string,
  keepAveonlineFlag: boolean = true
) => async(dispatch: any) => {
  const _dataService = new DataService()
  const data = {
    url: path,
    origin: config.landingIdentifier,
    email: email,
    catalogueId: catalogueId,
  }
    await _dataService
      .postElastic('/search/buyer', null, data)
      .then((res: AxiosResponse) => {
        const responseData = res.data.data ?? {};
        const { isAveonline, ...rest } = responseData;
        const payload = keepAveonlineFlag ? responseData : rest;
        dispatch({
          type: SEARCH_BUYER,
          payload
        })
        dispatch({
          type: LOADING_DETAILS,
          payload: false
        })
      })

      .catch((err) => { 
      dispatch({
        type: LOADING_DETAILS,
        payload: false
      })
      datadogLogs.logger.info('error request handleSearchBuyer', { name: 'post /search/buyer', body: data, error: err.message });
    })
}
